module.exports = require("@mui/material/Fade");